import React from 'react';

type ConditonalWrapperProps = {
  children: React.ReactElement;
  condition: boolean;
  wrapper: (children: React.ReactElement) => JSX.Element;
};

const ConditonalWrapper: React.FC<
  React.PropsWithChildren<ConditonalWrapperProps>
> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export default ConditonalWrapper;
